import { Prescription } from "@/models/Prescription";
import { DeliveryCode } from "@/models/DeliveryCode";

export interface OrderLabelData extends Prescription {
    fillDate: Date,
    packageID: number,
    productNameLong: string,
    quantity: number,
    rxNumber: number,
    rfNumber: number,

    totalPrice: number,
    patientPay: number,
    rfLeft: number,

    doctorLastName: string,
    doctorFirstName: string,

    patientLastName: string,
    patientFirstName: string,
    patientMiddleName: string,
    patientSex?: string,
    dateOfBirth: Date,
    orderDeliveryMethod: DeliveryCode,

    printed: Date,
    printedBy: string,
    hasAddons: boolean,
    promisedDate: Date
    transferToPharmacy?: string,
    addressState?: string,
    addressZip?: string,
    orderDate?: Date,
    isRxInMedSync?: boolean,
    isPatientInMedSync?: boolean,
    lastShippedDate?: Date,
}

export class OrderLabelData extends Prescription {
    patientName: string = "";

    constructor(obj?: OrderLabelData) {
        super(obj);
        if (obj) {
            Object.assign(this, obj);
            this.deliveryCode = obj.orderDeliveryMethod;
            // Populate patientName for sorting if not already set
            if (!this.patientName && (obj.patientLastName || obj.patientFirstName)) {
                this.patientName = `${obj.patientLastName || ''}, ${obj.patientFirstName || ''}`.trim();
            }
        }
    }
}
